import * as yup from 'yup';

// User info validation schema
export const userInfoSchema = yup.object({
  customer_name: yup
    .string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name cannot exceed 50 characters')
    .matches(/^[a-zA-Z\s.'-]+$/, 'Name contains invalid characters'),
  customer_email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  room_key: yup.string().optional(),
});

// Message validation schema
export const messageSchema = yup.object({
  message: yup
    .string()
    .required('Message is required')
    .min(1, 'Message cannot be empty')
    .max(1000, 'Message cannot exceed 1000 characters')
    .trim(),
});

// Schema-derived types to keep resolver and form types aligned
export type UserInfoFormData = yup.InferType<typeof userInfoSchema>;
export type MessageFormData = yup.InferType<typeof messageSchema>;

export default {
  userInfoSchema,
  messageSchema,
};
